class Emitter {

	private _callbacks: any;

	constructor() {

	}


	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	on: (event: any, fn: any) => this = (event: any, fn: any): this => {

		this._callbacks = this._callbacks || {};
		(this._callbacks['$' + event] = this._callbacks['$' + event] || [])
			.push(fn);
		return this;
	};

	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	once: (event: any, fn: any) => this = (event: any, fn: any): this => {
		function on(this: any): void {
			this.off(event, on);
			fn.apply(this, arguments);
		}

		on['fn'] = fn;
		this.on(event, on);
		return this;
	};

	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	off(event: any, fn: any): this {

		this._callbacks = this._callbacks || {};

		// all
		if (0 == arguments.length) {
			this._callbacks = {};
			return this;
		}

		// specific event
		let callbacks: any = this._callbacks['$' + event];
		if (!callbacks) return this;

		// remove all handlers
		if (1 == arguments.length) {
			delete this._callbacks['$' + event];
			return this;
		}

		// remove specific handler
		let cb;
		for (let i: number = 0; i < callbacks.length; i++) {
			cb = callbacks[i];
			if (cb === fn || cb.fn === fn) {
				callbacks.splice(i, 1);
				break;
			}
		}
		return this;
	}


	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param arg
	 * @return {Emitter}
	 */
	emit(event: any, ...arg: any[]): this {

		this._callbacks = this._callbacks || {};
		let args: Array<any> = [].slice.call(arg)
			, callbacks: any = this._callbacks['$' + event];

		if (callbacks) {
			callbacks = callbacks.slice(0);

			for (let call of callbacks) {
				call.apply(this, args);
			}
		}

		return this;
	}

	/**
	 * Return an array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	listeners(event: any): any {
		this._callbacks = this._callbacks || {};
		return this._callbacks['$' + event] || [];
	}

	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	hasListeners(event: any): boolean {
		return !!this.listeners(event).length;
	}

}

export {Emitter};